import _ from 'lodash'

const namespaced = true

const state = {}

const getters = {
  // coverByCarId
  // 车辆封面
  coverByCarId: (store, getters, rootState, rootGetters) => id => {
    const car = rootGetters['Car/carByCarId'](id)

    if (!car) {
      return null
    }

    const cover = _.chain(car.images)
      .get('cover')
      .head()
      .get('img')
      .value()

    return cover
  },

  // imagesGroupedByCategoryByCarId 图片详情对应的图片分类
  // 对应 ibs 车辆定妆照
  // - facade 外观
  // - interior_decoration 中控方向盘
  // - seats 车厢座椅
  // - attachment 后备箱及附件
  // - engine_room 机舱
  // - other 轮上及其他
  imagesGroupedByCategoryByCarId: (store, getters, rootState, rootGetters) => id => {
    const car = rootGetters['Car/carByCarId'](id)

    if (!car) {
      return null
    }

    const desired = {
      facade: {
        name: '外观',
        value: null,
      },

      interior_decoration: {
        name: '内饰',
        value: null,
      },

      other: {
        name: '其他',
        value: null,
      },
    }

    _.keys(car.images).forEach(rawkey => {
      _.keys(desired).forEach(desiredKey => {
        if (desiredKey === rawkey && car.images[rawkey]) {
          desired[desiredKey].value = car.images[rawkey]
        }
      })
    })

    return desired
  },

  // imagesGroupByCategoryFlattedbyCarId
  // “图片详情对应的图片分类”的 flat 版本
  imagesGroupByCategoryFlattedbyCarId: (store, getters, rootState, rootGetters) => id => {

    const car = rootGetters['Car/carByCarId'](id)
    const categories = getters['imagesGroupedByCategoryByCarId'](id)

    if (!car) {
      return null
    }

    return _.reduce(categories, (holder, category) => {
      const imgs = _.chain(category)
        .get('value')
        .map('img')
        .value()

      holder = [...holder, ...imgs]

      return holder
    }, [])
  },
}

const actions = {}

const mutations = {}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
